export default function PHP_lcfirst() {
  return (
    <div>
      <h1>PHP_lcfirst</h1>
    </div>
  );
}
